var added = {};
module.exports = function addRegionToMap(map, region) {
	var id = region.properties && region.properties.get('osmId') || region;

	if(!added[id]) {
		map.geoObjects.add(region);
		added[id] = region;
	} else {
		region = added[id];
	}

	return region;
};


/** WEBPACK FOOTER **
 ** ./src/scripts/lib/contacts/fn/addRegionToMap.js
 **/